








import { Component, Vue, Prop } from 'vue-property-decorator';
import {Other as mainTerms} from '@/const/terms/mainTerms';
@Component<ImageColumn>({
    name: 'ImageColumn',
})
export default class ImageColumn extends Vue {
    @Prop({ required: true, type: String }) private prop!: string;
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'center' }) private align!: string;
    @Prop({ type: [String, Number], default: '' }) private width!: number | string;
    @Prop({ type: [String, Number], default: 180 }) private minWidth!: number | string;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;
    @Prop({ type: String, default: 'url' }) private src!: string;

    private terms = mainTerms;

    private click(e: Event, row: any, property: string) {
        this.$emit('click', e, row, property);
    }
    private load(e: Event, row: any, property: string) {
        this.$emit('load', e, row, property);
    }
}
